module.exports = __webpack_public_path__ + "static/media/Participants_Logo.400ab9a1.svg";